export enum AlarmNotificationType {
  INSTANTANEOUS = 'INSTANTANEOUS',
  AGGREGATED = 'AGGREGATED'
}
